/**
 * TA 的公开时间线（UI-WORLD-LIVING-117-3）：GET /public/residents/{pet_id}/timeline（B 的 PUBLIC-RESIDENT-TIMELINE-117；不带分页参数，后端默认一页 30 条）。
 * - 照居民主页本身的读法分两路（服务层可选方法，没有就不读，页面只说此刻）：
 *   显式访客走 pets.publicResidentTimelineGuest（客户端的访客专用读法，首次即不带凭据，只认规范编号拼出的这一条路径）；
 *   其余走 pets.publicResidentTimeline（全站客户端的普通读法）。两路的缓存键分开，访客不借成员缓存；
 * - 只读最新一页，够挑「TA 的一天」「TA 最近见过的」「TA 的照片」；不翻页、不轮询（主页不是观察室）；
 * - 名单外（没公开、撤下、被领养、不存在）后端答 state=unknown、items 为空；读失败不重试。两种都只说此刻，不说技术话。
 */
import { useQuery } from "@tanstack/react-query";
import type { PublicResidentTimeline } from "@/shared/contracts";
import { queryKeys } from "@/shared/query/queryClient";
import { useServices } from "@/shared/services/registry";

export function useResidentTimeline(petId: string | null, guest: boolean) {
  const { pets } = useServices();
  const read = guest
    ? (typeof pets.publicResidentTimelineGuest === "function" ? pets.publicResidentTimelineGuest : null)
    : (typeof pets.publicResidentTimeline === "function" ? pets.publicResidentTimeline : null);
  return useQuery<PublicResidentTimeline>({
    queryKey: guest ? queryKeys.publicResidentTimelineGuest(petId ?? "-") : queryKeys.publicResidentTimeline(petId ?? "-"),
    queryFn: ({ signal }) => read!(petId!, signal),
    enabled: Boolean(petId && read),
    staleTime: 30_000,
    retry: false,
  });
}
